/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";

type MIDIStatus = "needs_setup" | "connected" | "browser_not_supported";

export interface MIDIEvent {
    event_type: "key_up" | "key_down";
    key: number;
    velocity: number;
    time: number;
}

export interface MIDIContext {
    deviceNames: Array<string> | null;
    status: MIDIStatus;
    setOnMIDIEvent: (callback: (event: MIDIEvent) => void) => void;
}

const INITIAL_CONTEXT = {
    deviceNames: null,
    status: "needs_setup" as MIDIStatus,
    setOnMIDIEvent: () => {
    },
};

export default React.createContext<MIDIContext>(INITIAL_CONTEXT);